import React from "react";

const Aborted = () => {
  return (
    <svg
      aria-hidden="true"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 8H3"
        stroke="#C24E00"
        strokeWidth="1.47059"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Aborted;
